import { combineReducers } from 'redux';
// slices
import notificationReducer from './slices/notification';

// ----------------------------------------------------------------------

const rootReducer = combineReducers({
  notification: notificationReducer,
});

export { rootReducer };
